// Tiny class-name merge helper. Per OC §3.3 / §3.8 hoist threshold —
// emerged at P-029 (2 uses inside `<PreviewIframe>`), crossed the 3-use
// threshold at P-030 (added 2 more in `<PreviewToolbar>` plus the
// `<PageContainer>` site that pre-existed with a renamed-but-identical
// shape).
//
// Hand-rolled per OC §3.8 — `clsx` / `classnames` would add a dep for a
// 5-line function the project genuinely needs only one variant of.
// Conditional-class composition (truthy / falsy / array forms) is NOT
// surfacing in this codebase; the only pattern is "base + optional
// extra". Keep the API narrow.

export function mergeClass(base: string, extra: string | undefined): string {
  return extra === undefined ? base : `${base} ${extra}`
}
